export const useUiStore = defineStore('ui', {
    state: () => ({
        sideBarState: true
    }),
    actions: {
        toggleSideBar(){
            this.sideBarState = !this.sideBarState
        },
        showSideBar(){
            this.sideBarState = true
        },
        hideSideBar(){
            this.sideBarState = false
        }
    },
})
